import { render, staticRenderFns } from "./CropTypeForm.vue?vue&type=template&id=116e5610&"
import script from "./CropTypeForm.vue?vue&type=script&lang=ts&"
export * from "./CropTypeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports